import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFinalDestinationList as getFinalDestinationListApi,
	getFinalDestination as getFinalDestinationApi,
	addNewFinalDestination as addNewFinalDestinationApi,
	updateFinalDestination as updateFinalDestinationApi,
	deleteFinalDestination as deleteFinalDestinationApi,
	existsFinalDestination as existsFinalDestinationApi,
} from '../../helpers/residue/backend_helper';

export const getFinalDestinationList = createAsyncThunk('finalDestinations/getFinalDestinationList', async () => {
	try {
		const response = getFinalDestinationListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFinalDestination = createAsyncThunk('finalDestinations/getFinalDestination', async finalDestination_id => {
	try {
		const response = getFinalDestinationApi(finalDestination_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const existsFinalDestination = createAsyncThunk('finalDestinations/existsFinalDestination', async rut => {
	try {
		const response = existsFinalDestinationApi(rut);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewFinalDestination = createAsyncThunk('finalDestinations/addNewFinalDestination', async finalDestination => {
	try {
		const response = addNewFinalDestinationApi(finalDestination);
		toast.success('Destino Final agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar finalDestination.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFinalDestination = createAsyncThunk('finalDestinations/updateFinalDestination', async (finalDestination) => {
		try {
			const response = updateFinalDestinationApi(finalDestination);
			toast.success('Destino Final actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar finalDestination.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFinalDestination = createAsyncThunk('finalDestinations/deleteFinalDestination', async finalDestination => {
	try {
		const response = await deleteFinalDestinationApi(finalDestination);
		toast.success('Destino Final eliminado exitosamente.', { autoClose: 3000 });
		return { finalDestination, ...response };
	} catch (error) {
		toast.error('Error al eliminar finalDestination.', { autoClose: 3000 });
		throw new Error(error);
	}
});
